export default function (dsf, options) {
  return {
    id: "",
    name: "",
    code: "",
    type: dsf.metadata.mmtype(3),
    at: "",
    level: 0,
    currentControl: null,
    controls: [],
    validate: dsf.metadata.validate(),
    defaultValue: null,
    valueAttributes: [
      {
        name: "JSON数据",
        code: "json",
        type: dsf.metadata.getDataType("json"),
        length: "",
        defaultValue: null,
        unit: null,
        encrypt: false,
        textType: "normal"
      }
    ]
  };
}
